<!--
 * @LastEditTime: 2020-09-03 10:10:10
 * @Description: 排行榜
 * @Date: 2020-02-27 20:46:02
 * @Author: @虾哔哔
 -->
<template>
  <div class="ranking">
    <div class="ranking_card">
      <el-card class="card">
        <el-row>
          <el-col :span="20">
            <el-button
              type="text"
              v-for="item in btnList"
              :key="item.id"
              @click="changeTab(item)"
              :class="{'highLight': currentId == item.id}"
            >{{item.text}}</el-button>
          </el-col>
          <el-col :span="4" style="text-align:right">
            <span class="download" v-if="currentId !==3" @click="download">
              <i class="iconxiazai- iconfont"></i>
            </span>
          </el-col>
        </el-row>
        <div class="tableContent" style="margin-top:30px;padding-bottom:20px">
          <!-- 热门知识排行榜 -->
          <el-table :data="data.questions" border max-height="350" v-if="currentId == 1">
            <el-table-column show-overflow-tooltip="" prop="question" label="知识点" :resizable="false"></el-table-column>
            <el-table-column prop="count" label="咨询次数" :resizable="false"></el-table-column>
          </el-table>
          <!-- 商品推荐排行榜 -->
          <el-table :data="data.goods" border max-height="350" v-if="currentId == 2">
            <el-table-column show-overflow-tooltip="" prop="goods" label="商品名称" :resizable="false"></el-table-column>
            <el-table-column prop="count" label="推荐次数" :resizable="false"></el-table-column>
          </el-table>
          <!-- 活动推荐排行榜 -->
          <el-table :data="data.activities" border max-height="350" v-if="currentId == 3">
            <el-table-column show-overflow-tooltip="" prop="activity" label="活动名称" :resizable="false"></el-table-column>
            <el-table-column prop="count" label="推荐次数" :resizable="false"></el-table-column>
          </el-table>
        </div>
      </el-card>
      <!-- 热门知识排行榜 -->
      <!-- <el-card>
				<div class="ranking_card_header" slot="header">
					<span>热门知识排行榜</span>
					<el-button type="text" @click="getTopQuestionExport()">点击下载</el-button>
				</div>
				<el-table :data="data.questions" max-height="200">
					<el-table-column prop="question" label="知识点"> </el-table-column>
					<el-table-column prop="count" label="咨询次数"> </el-table-column>
				</el-table>
      </el-card>-->
      <!-- 商品推荐排行榜 -->
      <!-- <el-card>
				<div class="ranking_card_header" slot="header">
					<span>商品推荐排行榜</span>
					<el-button type="text" @click="getTopGoodsExport()">点击下载</el-button>
				</div>
				<el-table :data="data.goods" max-height="200">
					<el-table-column prop="goods" label="商品名称"> </el-table-column>
					<el-table-column prop="count" label="推荐次数"> </el-table-column>
				</el-table>
      </el-card>-->
      <!-- 活动推荐排行榜 -->
      <!-- <el-card>
				<div slot="header">
					<span>活动推荐排行榜</span>
				</div>
				<el-table :data="data.activities" max-height="200">
					<el-table-column prop="activity" label="活动名称"> </el-table-column>
					<el-table-column prop="count" label="推荐次数"> </el-table-column>
				</el-table>
      </el-card>-->
    </div>
    <!-- 下载专用iframe -->
    <baseDownloadPage ref="DownloadPage" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          questions: [],
          goods: [],
          activities: []
        };
      }
    },
    time: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      currentId: 1,
      btnList: [
        {
          text: "热门知识",
          id: 1
        },
        {
          text: "商品推荐",
          id: 2
        },
        {
          text: "推荐活动",
          id: 3
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["shopId"])
  },
  mounted() {},
  methods: {
    getTopQuestionExport() {
      let params = {
        authority_id: this.shopId,
        start: dayjs(this.time[0]).format("YYYY-MM-DD"),
        end: dayjs(this.time[1]).format("YYYY-MM-DD")
      };
      this.$store
        .dispatch("ServiceOverview/getTopQuestionExport", params)
        .then(res => {
          if (res.data.code === 2000) {
            this.$refs.DownloadPage.download(res.data.data);
            this.$message.success({
              message: res.data.desc,
              center: true
            });
          }
        });
    },
    //
    getTopGoodsExport() {
      let params = {
        authority_id: this.shopId,
        start: dayjs(this.time[0]).format("YYYY-MM-DD"),
        end: dayjs(this.time[1]).format("YYYY-MM-DD")
      };
      this.$store
        .dispatch("ServiceOverview/getTopGoodsExport", params)
        .then(res => {
          if (res.data.code === 2000) {
            this.$refs.DownloadPage.download(res.data.data);
            this.$message.success({
              message: res.data.desc,
              center: true
            });
          }
        });
    },
    changeTab(val) {
      console.log(val);
      this.currentId = val.id;
    },
    download() {
      if (this.currentId == 1) {
        this.getTopQuestionExport();
      } else if (this.currentId == 2) {
        this.getTopGoodsExport();
      }
    }
  }
};
</script>

<style lang="less" scoped>
@deep: ~">>>";
.ranking {

  .ranking_card {
    height: 450px;
    border-radius: 10px;
    @{deep}.el-card {
      height: 448px;
      border-radius: 10px;
      box-shadow: none;
      border: none;
      .el-table{
        border-radius: 4px;
       
      }
      .el-table__row:nth-child(odd) {
        background: #f9f9f9;
      }
      .el-table--border td {
        border: none;
        font-size: 12px;
        height: 40px;
        font-weight:400;
        color:#767E91;
      }
      .el-table th{
        background: none;
        font-size: 12px;
        border-right: none;
        line-height: 40px;
      }
      .el-button--text {
        color: black;
        font-size: 16px;
        padding: 0 18px 0 0;
        font-weight: 600;
      }
      .highLight {
        color: #4162fb;
      }
      .download {
        // display: inline-block;
        // width:16px;
        // height:16px;
        // background:rgba(65,98,251,1);
        // border-radius:2px;
        // padding-left: 2%;
        // box-sizing: border-box;
        cursor: pointer;
        i {
          background:rgba(65,98,251,1);
          color: white;
          font-size: 8px!important;
          padding: 2px 0 2px 4px;
          border-radius:2px;
        }
      }
    }
  }
}
</style>
